import { render, staticRenderFns } from "./MenuPrivilege.vue?vue&type=template&id=d8576352&"
import script from "./MenuPrivilege.vue?vue&type=script&lang=js&"
export * from "./MenuPrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports